import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { MaterialModule } from 'src/app/material.module';
import { TranslateModule } from '@ngx-translate/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { IpdService } from '../../ipd.service';
import { IBedOccupancy, IBedOccupancyResult } from '../iipd-management';
import { EmptyStateComponent } from 'src/app/shared/empty-state/empty-state.component';

@Component({
  selector: 'app-bed-occupancy',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MaterialModule,
    TranslateModule,
    TablerIconsModule,
    EmptyStateComponent
  ],
  templateUrl: './bed-occupancy.component.html',
  styleUrls: ['./bed-occupancy.component.scss']
})
export class BedOccupancyComponent implements OnInit {
  occupancyData: IBedOccupancyResult | null = null;
  isLoading = false;
  bedFilter: 'all' | 'available' | 'occupied' = 'available';

  constructor(
    private ipdService: IpdService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.loadOccupancy();
  }

  loadOccupancy(): void {
    this.isLoading = true;
    this.ipdService.getBedOccupancy().subscribe({
      next: (res) => {
        if (res.isSuccess) {
          this.occupancyData = res.result;
        }
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }

  onBedClick(bed: IBedOccupancy): void {
    if (this.isOccupied(bed) && bed.ipdId && bed.patientId) {
      this.router.navigate(['/ipd/admit', bed.ipdId, 'patient', bed.patientId]);
    }
  }

  isOccupied(bed: IBedOccupancy): boolean {
    return bed.status === 'Occupied' || bed.status === 2;
  }

  isBedVisible(bed: IBedOccupancy): boolean {
    if (this.bedFilter === 'all') return true;
    if (this.bedFilter === 'available') return !this.isOccupied(bed);
    return this.isOccupied(bed);
  }

  hasVisibleBeds(room: { beds: IBedOccupancy[] }): boolean {
    return room.beds.some(b => this.isBedVisible(b));
  }

  hasVisibleBedsInWard(ward: any): boolean {
    return ward.rooms?.some((room: any) =>
      room.beds?.some((bed: any) => this.isBedVisible(bed))
    );
  }

  onBedFilterChange(value: 'all' | 'available' | 'occupied'): void {
    this.bedFilter = value;
  }

  setOccupiedFilter() {
    if (!this.occupancyData?.occupiedBeds) {
      return;
    }
    this.bedFilter = 'occupied';
  }

  goToWard() {
    this.router.navigate(['/ipd']);
  }

}
